import { shape, bool } from 'prop-types';
import React from 'react';

import { PortableText } from '@/components/PortableText/PortableText';
import LazyYouTube from '@/components/Youtube';

import { Text } from '../../../module/Text';

import styles from './LightBox.module.scss';

export default function LightBox({ video, description }) {
  const { youtube, videoDescription } = video;

  return (
    <div
      className={`${styles.wrapper} ${description ? styles.withDescription : ''}`}
    >
      <div className={styles.videoContainer}>
        <div className={styles.container}>
          <div className={styles.videoWrapper}>
            <div className={styles.video}>
              <LazyYouTube
                url={youtube.url}
                autoPlay
                loop={false}
                background={false}
              />
            </div>
          </div>
        </div>
      </div>

      {description && (
        <div className={styles.description}>
          {videoDescription && (
            <Text className={styles.markdown}>
              <PortableText content={videoDescription} />
            </Text>
          )}
        </div>
      )}
    </div>
  );
}

LightBox.propTypes = {
  video: shape({
    youtube: shape({}),
    videoDescription: shape({}),
  }),
  description: bool,
};

LightBox.defaultProps = {
  video: {
    youtube: {},
    videoDescription: {},
  },
  description: false,
};
